module.exports = __webpack_public_path__ + "img/MT4.3cf420ba.png";